import useId from '../utils/useId';
import * as React from 'react';
export const rabobankSvg = React.forwardRef(function rabobankSvgInner(
  props,
  ref,
) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  const id_2 = baseId + '_2';
  const id_3 = baseId + '_3';
  const id_4 = baseId + '_4';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 .097h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#bi_rabobank__a_${id_0})`,
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'm7.33 22.166.045.713c.145 2.647 3.185 5.192 8.48 5.192 5.309 0 8.305-2.574 8.494-5.222l.044-.698-17.062.015Z',
        fill: `url(#bi_rabobank__b_${id_1})`,
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M7.68 20.406c-1.527 3.128 1.862 6.662 8.175 6.662 6.327 0 9.716-3.534 8.189-6.662-1.106-2.254-4.655-3.709-8.175-3.709-3.52 0-7.084 1.455-8.189 3.71Z',
        fill: `url(#bi_rabobank__c_${id_2})`,
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm12.659 17.164-.045.055.445.453.116.014.045-.056-.448-.451-.113-.015Zm3.21.26c-2.807 0-5.527 1.193-6.196 2.982v-.014c-.844 2.269 1.818 4.596 6.181 4.596 4.364 0 7.04-2.327 6.197-4.596-.655-1.79-3.375-2.968-6.182-2.968Zm-.16 9.311.01-1.39.14-.1.137.1.007 1.39-.146.116-.148-.116Zm5.408-1.026.017-.143-1.092-1.097-.183-.03-.028.127 1.087 1.107.2.037Zm2.678-2.72.09.111-.154.034-1.514-.512-.075-.108.148-.03 1.505.504Zm.035-2.589-.132-.06h-1.326l-.077.06.127.063h1.334l.074-.063Zm-2.045-2.053.132.017-.006.066-.909.306-.132-.02.008-.067.907-.302Zm-11.967.082-.006-.063.133-.02.906.305.009.067-.133.018-.909-.306ZM7.895 20.4l.074.062h1.334l.127-.062-.077-.062H8.029l-.134.062Zm.095 2.732-.154-.03.09-.115 1.505-.504.149.03-.075.107-1.515.512Zm2.608 2.579.198-.038 1.09-1.107-.027-.128-.185.032-1.095 1.097.019.144Z',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M19.273 18.064c-.146.015-.19.102-.32.117-.146.029-.262-.015-.262-.015-.19-.029-.233-.087-.436 0-.059.131-.291.204-.233.335.044.072.204.043.247.043.058 0 .131-.058.19-.043.21.018.41.094.581.218.29.247.64.64.83.945l.043.058.072.146.03.044c.087.16.203.29.261.523-.581 0-1.163-.247-1.163-.247l-.087-.044S18.662 20 18.123 20h-1.106c-.204-.044-.364-.204-.364-.204l-.29-.262c-.437-.218-1.164.771-1.164.771s-.218.102-.19.175c.045.073.48.116.54.102l.435-.146c.204-.189.946.03.946.03a43.83 43.83 0 0 0 2.502.61c.276.102 1.163.422 1.498.51l1.28.334c.662.355 1.372.61 2.109.756l.014-.087c.059-.247.073-.495.073-.756v-.044a3.459 3.459 0 0 0-.218-1.062l-.698-.087-1.062-.087-.145-.03c-.175-.029-.67-.203-.83-.407-.174-.218-.145-.232-.174-.276a6.782 6.782 0 0 0-.436-.538c-.291-.32-.931-.582-1.018-.728-.102-.145-.146-.29-.204-.378-.044-.087-.146-.145-.291-.145h-.058v.014Zm3.214 1.178-.116.102c-.03.058.073.146.073.146l.102.087c.305.204.858.233 1.134.233l-.45-.538h-.015l-.553-.073a.37.37 0 0 0-.175.043Zm-1.527 3.579c-.233.014.145.538.145.538.219.145.975.29 1.135.305.16.015.698.146.698.146h.233l.582.145c.164-.258.305-.531.421-.814-.64.029-1.672.189-2.4-.146l-.203-.058s-.218-.116-.538-.116h-.073Z',
        fill: '#3E373F',
        fillOpacity: 0.55,
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M15.2 5.7c0 .044.073.859.175.99.043.043.116.058.203.145.03.03.044.131.03.175 0 .349-.32.363-.568.465-.582.247-.727.771-.727 1.353-.19.48-.291.8-.32.887-.437.437-.626 1.455-1.018 2.037-.219.29-.582.32-.539.829.015.261.044.465.306.596.145.058.232 0 .334-.102l.044-.087c.03-.247-.058-.131.116-.393.19-.262.073-.334.204-.509.32-.407.655-.8 1.018-1.164.233-.247.35-.654.451-.974.087.64-.014 1.28.044 1.92.043.407.45 1.134.61 1.542-.014.247 0 1.149-.043 1.629 0 .29-.03.654.102.93.072.292.087.408.087.728l.044 1.775s.421.945.465.523c.03-.29.116-.669.204-.989.262-.858.334-.96.116-1.876l.146-.858c.145.232.349.698.48.916.16.29.509.495.727.756.204.277.407.655.393 1.004-.117.204.8-.524.727-.727-.058-.146-.175-.146-.35-.204-.276-.087-.48-.713-.552-.974-.116-.422-.335-.742-.582-1.019-.189-.8-.189-1.309-.305-2.007l.189-.742c.203-1.018-.393-1.309-.393-1.89 0-.146.146-.772.335-1.31.101.32.305.858.48 1.048.014.145 0 .261.073.407.218.553.552 1.062.712 1.643.03.102-.029.219-.072.291-.088.19-.044.538 0 .728l.072.029c-.043.247 0 .392.146.392.29-.014.45-.538.436-.8 0-.552-.102-.77-.145-1.018-.204-.974 0-1.28-.553-2.225l-.306-.728c-.058-.494-.116-1.032-.422-1.338-.261-.29-.32-.203-.625-.305-.8-.262-.247-.946-.233-1.484.015-.654-.363-.887-.843-.916H16c-.378 0-.67.233-.815.887l.015.015Z',
        fill: `url(#bi_rabobank__d_${id_3})`,
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M15.418 5.856c0 .044.015.698.117.83.189.145.29.101.29.45-.014.291-.203.48-.465.567-.407.146-.625.233-.77.655a2.15 2.15 0 0 0-.074.625v.015l-.349.945c-.509.524-.625 1.688-1.163 2.182-.335.32-.437.35-.32.858.014.044.116.117.145.146.03 0 .058-.03.073-.044h.014c.03-.262 0-.233.146-.48.145-.218.072-.32.204-.509.334-.407.668-.829 1.032-1.193.248-.261.568-1.09.64-1.381.015-.059.044-.073.058-.03.044.553.146 1.019.131 1.571-.043 1.164.015 1.106.437 2.139.072-.437.189-1.062.407-1.295-.291 1.135-.306 2.75-.335 3.244-.029.247-.087.654.03.872.043.16.043.408.043.582v1.964l-.16.873a1.6 1.6 0 0 1-.625.8c-.073.043-.262.145-.262.232 0 .146.887.393 1.09.073.146-.233.277-.364.452-.538.29-.262-.03-.538 0-.902.072-.625.349-1.163.436-1.774.058-.35 0-.684-.16-1.091l.145-1.12c.146.189.262.509.393.77.218.451.218.495.611.873.116.131.262.291.35.437.188.29.305.567.29.901-.145.248-.189.233-.363.379 0 0-.044.145.116.145.582 0 .509-.305.727-.698.146-.247.538-.625.102-.771-.145-.044-.32-.087-.393-.218-.32-.524-.32-.538-.48-1.018a1.55 1.55 0 0 0-.48-.699 2.79 2.79 0 0 1-.247-.887c-.058-.465-.131-.8-.204-1.28.218-.887.364-1.076-.029-1.934a1.6 1.6 0 0 1-.174-.64c0-.437.203-1.106.349-1.44.058-.131.174-.175.247-.146.014.32.407 1.091.582 1.266.014.145 0 .276.058.407.247.567.524 1.076.684 1.658.058.204 0 .291-.073.466a1.443 1.443 0 0 0 0 .48l.102.043c-.03.117-.058.335 0 .335.145 0 .262-.437.247-.626-.014-.582-.116-.829-.145-1.003-.204-.96-.044-1.222-.582-2.153l-.32-.756c-.03-.393-.117-1.28-.611-1.44L17.09 7.5c-.655-.204-.655-.713-.466-1.251.146-.495.175-1.062-.538-1.12h-.058c-.393 0-.524.334-.61.713v.014Z',
        fill: `url(#bi_rabobank__e_${id_4})`,
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_rabobank__b_${id_1}`,
          x1: 7.331,
          y1: 25.111,
          x2: 24.393,
          y2: 25.111,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#000095',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#003',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_rabobank__c_${id_2}`,
          x1: 3.014,
          y1: 21.672,
          x2: 9.403,
          y2: 33.447,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#FFCA32',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.161,
          stopColor: '#FFA720',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.473,
          stopColor: '#FB6200',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.616,
          stopColor: '#E34A00',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.794,
          stopColor: '#D63D00',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#C30',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_rabobank__d_${id_3}`,
          x1: 12.722,
          y1: 7.785,
          x2: 20.621,
          y2: 15.97,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#F9C19B',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#C2BDD7',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_rabobank__e_${id_4}`,
          x1: 11.618,
          y1: 10.45,
          x2: 20.35,
          y2: 15.161,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#040492',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#221E3A',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `bi_rabobank__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          transform: 'translate(7.316 4.799)',
          d: 'M0 0h17.091v23.273H0z',
        }),
      ),
    ),
  );
});
rabobankSvg.defaultProps = {
  width: '32',
  height: '33',
  viewBox: '0 0 32 33',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var rabobank = {
  category: 'brand',
  colorable: false,
  name: 'rabobank',
  svg: rabobankSvg,
};
